import { render, staticRenderFns } from "./ExpansionPanelTitleWithText.vue?vue&type=template&id=58ab555f&"
import script from "./ExpansionPanelTitleWithText.vue?vue&type=script&lang=js&"
export * from "./ExpansionPanelTitleWithText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports